import { render, staticRenderFns } from "./ListadoSolicitudesInscripciones.vue?vue&type=template&id=00c50d5d"
import script from "./ListadoSolicitudesInscripciones.vue?vue&type=script&lang=js"
export * from "./ListadoSolicitudesInscripciones.vue?vue&type=script&lang=js"
import style0 from "./ListadoSolicitudesInscripciones.vue?vue&type=style&index=0&id=00c50d5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports